export const wlpData = {
  default: {
    title: 'ENS Portal',
    wlpName: '',
  },
  'ensgb-360pay.cabie.uk': {
    title: '360pay ENS Portal',
    wlpName: '360PAY',
    headerBgColor: '#ffffff',
    headerTextColor: '#000000',
    navButtonColor: '#000000',
  },
  'ensgb-360pay-dev.azurewebsites.net': {
    title: '360pay ENS Portal',
    wlpName: '360PAY',
    headerBgColor: '#ffffff',
    headerTextColor: '#000000',
    navButtonColor: '#000000',
  },
  'ensgb-360pay-uat.azurewebsites.net': {
    title: '360pay ENS Portal',
    wlpName: '360PAY',
    headerBgColor: '#ffffff',
    headerTextColor: '#000000',
    navButtonColor: '#000000',
  },
};
